import { useRef } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { FormParticipante } from "../abm/actividades/FormParticipante";

export const ModalActividadesCreateParticipante = ({
  showState = [false, () => {}],
  updateItem,
  data = {}
}) => {
  const [show, setShow] = showState;
  const formRef = useRef();

  const handleCancel = () => {
    setShow(false);
  };

  const handleConfirm = (participante) => {
    updateItem(participante);
  };

  return (
    <Dialog
      open={show}
      onClose={handleCancel}
      maxWidth="sm"
      fullWidth
      PaperProps={{sx: {overflow: "visible"}}}
    >
      <DialogTitle>Agregar estadística de participantes</DialogTitle>
      <DialogContent sx={{padding: 0, overflow: "visible"}}>
        <FormParticipante
          ref={formRef}
          item={{
            id: 0,
            id_categoria: null,
            id_genero: null,
            id_origen: null,
            cantidad: "",
            remove: false
          }}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
          data={data}
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="success"
          onClick={event => formRef.current?.submit(event)}
        >
          Guardar
        </Button>
        <Button variant="outlined" color="error" onClick={handleCancel}>
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
